export const AssessmentItemsEN = {
    "assessmentItem": {
        "breadcrumb": "Competency criteria setting",
        "heading": {
            "item": "Assessment Item",
            "type": "Assessment Type",
            "add": "Create Assessment Item",
            "update": "AssessmentEmployeeDetailUpdate Assessment Item",
            "info": "General Information",
            "addType": "Add Assessment Type",
            "detail": "Assessment Index",
            "generalInfo": "General Infomation",
            "assessmentScale": "Assessment Scale"
        },
        "label": {
            "name": "Name",
            "status": "Status",
            "pointOne": "Point One",
            "pointTwo": "Point Two",
            "pointThree": "Point Three",
            "pointFour": "Point Four",
            "pointFive": "Point Five",
            "exact": "Allows scoring accurate to 0.5",
            "description": "Description",
            "type": "Assessment Type",
            "dynamic": "Assessment Type"
        },
        "placeholder": {
            "name": "Enter Name",
            "status": "Enter Status",
            "pointOne": "Enter Point One",
            "pointTwo": "Enter Point Two",
            "pointThree": "Enter Point Three",
            "pointFour": "Enter Point Four",
            "pointFive": "Enter Point Five",
            "exact": "Enter Allows scoring accurate to 0.5",
            "description": "Enter Description",
            "type": "Enter Assessment Type"
        },
        "message": {
            "add": "Create Success",
            "update": "AssessmentEmployeeDetailUpdate Success",
            "delete": "Delete Success",
            "required": {
                "name": "Name is required",
                "type": "Type is required",
                "pointOne": "Point One is required",
                "pointTwo": "Point Two is required",
                "pointThree": "Point Three is required",
                "pointFour": "Point Four is required",
                "pointFive": "Point Five is required"
            }
        },
        "value": {
            "status": {
                "actived": "ACTIVED",
                "inactived": "INACTIVED"
            },
            "isExact": {
                "yes": "Yes",
                "no": "No"
            }
        }
    }
}